import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { formatCountCompact } from 'utils/helpers';
import { Text } from 'components/core/Typography';
import './ReviewTabs.scss';

const VERIFIED_TAB = 'verified';
const GOOGLE_TAB = 'google';

export { VERIFIED_TAB, GOOGLE_TAB };

export function ReviewTabs({
	verifiedCount,
	googleCount,
	activeTab,
	onTabChange,
}) {
	const verifiedTabRef = useRef(null);
	const googleTabRef = useRef(null);

	const handleToggle = (tab) => () => {
		if (tab === activeTab) return;
		onTabChange(tab);
	};

	const handleKeyDown = (tab) => (e) => {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			handleToggle(tab)();
		} else if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
			e.preventDefault();
			const nextTab = tab === VERIFIED_TAB ? GOOGLE_TAB : VERIFIED_TAB;
			const nextRef = nextTab === VERIFIED_TAB ? verifiedTabRef : googleTabRef;
			onTabChange(nextTab);
			nextRef.current?.focus();
		}
	};

	return (
		<div className="review-tabs" role="tablist">
			<span
				ref={verifiedTabRef}
				role="tab"
				tabIndex={activeTab === VERIFIED_TAB ? 0 : -1}
				aria-selected={activeTab === VERIFIED_TAB}
				className={classnames('review-tabs__tab', {
					'review-tabs__tab--active': activeTab === VERIFIED_TAB,
				})}
				onClick={handleToggle(VERIFIED_TAB)}
				onKeyDown={handleKeyDown(VERIFIED_TAB)}
			>
				<Text
					last
					size="small"
					weight={activeTab === VERIFIED_TAB ? 'bold' : 'regular'}
					color="black"
				>
					{`Verified (${verifiedCount})`}
				</Text>
			</span>
			<span
				ref={googleTabRef}
				role="tab"
				tabIndex={activeTab === GOOGLE_TAB ? 0 : -1}
				aria-selected={activeTab === GOOGLE_TAB}
				className={classnames('review-tabs__tab', {
					'review-tabs__tab--active': activeTab === GOOGLE_TAB,
				})}
				onClick={handleToggle(GOOGLE_TAB)}
				onKeyDown={handleKeyDown(GOOGLE_TAB)}
			>
				<Text
					last
					size="small"
					weight={activeTab === GOOGLE_TAB ? 'bold' : 'regular'}
					color="black"
				>
					{`Google (${formatCountCompact(googleCount)})`}
				</Text>
			</span>
		</div>
	);
}

ReviewTabs.propTypes = {
	verifiedCount: PropTypes.number.isRequired,
	googleCount: PropTypes.number.isRequired,
	activeTab: PropTypes.oneOf([VERIFIED_TAB, GOOGLE_TAB]).isRequired,
	onTabChange: PropTypes.func.isRequired,
};

export default ReviewTabs;
